/* Below 768px the collection's sort control lives inside the filter sheet (Mobile 1 `1b` draws
 * "Sort" as the sheet's first group); above it, in the toolbar where the desktop artboard draws
 * it. The control is one node with one name, moved between the two places, so the facets form
 * never carries two `sort_by` fields. facets.js re-renders the toolbar on every filter change,
 * so the move re-runs after each render and keeps only the newest copy. */
(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  const place = () => {
    const all = [...document.querySelectorAll('.dc-53faed')];
    if (!all.length) return;
    const sort = all[all.length - 1];
    for (const el of all) if (el !== sort) el.remove();
    const slot = document.querySelector('[data-dc-sheet-sort]');
    const home = document.querySelector('.collection-actions-main');
    const target = mq.matches ? slot : home;
    if (target && sort.parentElement !== target) target.appendChild(sort);
  };
  place();
  mq.addEventListener('change', place);
  const actions = document.getElementById('CollectionActions');
  if (actions) new MutationObserver(place).observe(actions, { childList: true, subtree: true });

  // The sheet opens and closes through a hidden checkbox; its "Filter & sort" and "Show results"
  // labels carry role="button" and tabindex="0", but a label has no key behaviour of its own, so
  // Enter and Space did nothing. They toggle the checkbox now, as a click on the label does.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const label = e.target.closest && e.target.closest('label[role="button"][for^="dc-sheet-"]');
    if (!label) return;
    e.preventDefault();
    label.click();
  });
})();
